
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import NewConnectionView from "../components/newConnectionView";
import Footer from "../components/footer";

function NewConnectionViewPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <NewConnectionView /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default NewConnectionViewPage;
